// types
import React from "react";

import type { Recipe } from "~types/recipe";

import { Box, Typography, useTheme } from "@mui/material";

import Pan from "~public/icons/Pan/Pan.svg";

interface RecipePanPreviewProps {
  recipe: Recipe;
}

export const RecipePanPreview = ({
  recipe
}: RecipePanPreviewProps): JSX.Element => {
  const { title } = recipe;
  const theme = useTheme();

  const panColor = () => {
    if (recipe.convenience_level?.[0]) {
      return theme.palette.green.main;
    }
    if (recipe.convenience_level?.[1]) {
      return theme.palette.pink.main;
    }
    if (recipe.convenience_level?.[2]) {
      return theme.palette.orange.main;
    }

    return theme.palette.grey[50];
  };

  return (
    <Box
      id={`recipe-pan_preview-${recipe.pk}`}
      data-qa={"recipe-pan-preview"}
      className="recipe_pan"
      sx={{
        position: "relative",
        width: "min-content",
        "& .pan path": { fill: panColor() },
        height: 70,
        overflow: "visible",
        display: "flex",
        alignItems: "center",
        maxWidth: "calc(50% - 16px)"
      }}>
      <Pan
        className="pan"
        style={{
          fontSize: 70,
          position: "absolute",
          top: 0,
          left: 0
        }}
      />
      <Box
        className="info_block"
        sx={{
          mb: 2.5,
          position: "relative",
          width: "100px",
          ml: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          transition: "all 600ms ease-in-out"
        }}>
        <Typography
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 4
          }}
          fontWeight={600}
          fontSize={16}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default RecipePanPreview;
